export { default } from './ServerStyleSheets';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/ServerStyleSheets/index.js
// module id = 382
// module chunks = 0